import { render, staticRenderFns } from "./IndexActiveCompany.vue?vue&type=template&id=2b1e45ca&"
import script from "./IndexActiveCompany.vue?vue&type=script&lang=js&"
export * from "./IndexActiveCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports